
import "C:/github-runners/esig-portal/_work/esig-client/esig-client/src/layout/Header/NoticeBar/styles.less?modules";
export default {"containerNotice": `containerNotice-rDahGBg_`}
